import { render, staticRenderFns } from "./ManualTransactions.vue?vue&type=template&id=2bb4e5b8"
import script from "./ManualTransactions.vue?vue&type=script&lang=js"
export * from "./ManualTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports